import { render } from "./BlockIptuEmpresarial.vue?vue&type=template&id=15384bb2"
import script from "./BlockIptuEmpresarial.vue?vue&type=script&lang=js"
export * from "./BlockIptuEmpresarial.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/CampoForm/components/BlockIptuEmpresarial.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15384bb2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15384bb2', __exports__)) {
    console.log('reload')
    api.reload('15384bb2', __exports__)
  }
  
  module.hot.accept("./BlockIptuEmpresarial.vue?vue&type=template&id=15384bb2", () => {
    console.log('re-render')
    api.rerender('15384bb2', render)
  })

}


export default __exports__